import type { MaybeRefOrGetter } from "vue";

/** Look up a `WebsitePage` by its route path.
 * AlleFolders' only has the NL locale, so strip it from the path if needed.
 * Else just find a website page based on the path.
 *
 * Accepts a plain string or a reactive getter, so callers that persist across
 * navigations can stay in sync with the current route, useful for layouts.
 */
export const useWebsitePagePath = (path: MaybeRefOrGetter<string>) => {
  const host = useCurrentHost();

  const variables = computed(() => {
    const resolvedPath = toValue(path);

    return {
      websitePage: {
        path:
          host.value === "allefolders" && resolvedPath.startsWith("/nl/")
            ? resolvedPath.slice(3)
            : resolvedPath,
      },
    };
  });

  return { websitePagePath: variables };
};
